export default class WSError {
  statusCode: number;
  error: { type: string; description: string };
}
